<div class="offCanvas__container">
  <div class="offCanvas__contentWrapper">
    <div class="offCanvas__header">
      <div class="offCanvas__title">Multi-Factor Authentication (MFA)</div>
      <img (click)="onCloseIconClick(false)" class="offCanvas__crossIcon"
        src="../../../../assets/Images/organisation-structure/Cross.svg" alt="cross icon">
      </div>
      @if (mfaAutentication==='step1') {
        <div class="qr-details">
          <div class="userManagementUsersList__user-management-section1">
            <p>Registered Devices
            </p>
            <!-- {{mfaEnabledDetails?.isMfaEnabled }}{{isMFA}} -->
            @if (isMfa) {
              <app-common-button buttonClass="smallFilledButton" buttonLabel="Register Device"
              (clickEvent)="movetoNext(mfaAutentication)"></app-common-button>
            }
            @if (isMFA && mfaEnabledDetails?.isMfaEnabled) {
              <app-common-button [loadingIcon]="loadingIcon" buttonClass="smallFilledButton" buttonLabel="Disabled"
              (clickEvent)="disabledUserMfa()"></app-common-button>
            }
          </div>
          <table class="custom-table-list" aria-label="users">
            <thead class="custom-table-list-headings">
              <th class="custom-col-width-30">Device Name</th>
              <th class="custom-col-width-30">Registered On</th>
              <th class="custom-col-width-30">Disabled</th>
            </thead>
            <tbody>
              @if (mfaEnabledDetails?.mfaDevice) {
                <tr class="custom-table-list-row-main cursor-pointer">
                  <td class="custom-col-width-30 userTable__status clickable-td">
                    {{ mfaEnabledDetails?.mfaDevice}}
                  </td>
                  <td class="custom-col-width-30 userTable__status clickable-td">
                    {{ mfaEnabledDetails?.enabledAt | date : "dd MMM yy, hh:mm a"}}
                  </td>
                  <td class="custom-col-width-30 userTable__status clickable-td">
                    @if (!isMFA) {
                      <div class="fa-ban">
                        <app-common-icon [faIcon]="faBan"
                          (clickEvent)="disableMfa(mfaEnabledDetails?.mfaDevice)"
                        [loadingIcon]="loadingIcon"></app-common-icon>
                      </div>
                    }
                  </td>
                </tr>
              }
              @if (!mfaEnabledDetails?.mfaDevice) {
                <tr
                  >
                 <td class="custom-col-width-100 d-flex justify-content-center">
                            <p class="text-danger">No Device Registered!</p>
                        </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
      @if (mfaAutentication==='step2') {
        <div class="qr-details">
          <p class="userManagementUsersList__user-management-section1">Set Up Your authenticator app</p>
          <form [formGroup]="deviceForm">
            <div class="column">
              <div class="col-md-6">
                <div class="input-text-width">
                  <app-input-filed label="Device Name" placeholder="Device Name" [control]="$any(deviceForm).controls['deviceName']"
                  [starIcon]="'*'"></app-input-filed>
                  @if (deviceForm.get('deviceName')?.invalid &&
                    (deviceForm.get('deviceName')?.dirty ||
                    deviceForm.get('deviceName')?.touched)) {
                    <div>
                      @if (deviceForm.get('deviceName')?.errors?.['required']) {
                        <div>
                          <small class="text-danger">Device Name is required.</small>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </form>
          <div class="steps__text">
            Install a compatible application such as Google Authenticator, Authenticator, Duo Mobile, or Authy app
            on your
            mobile device or computer
          </div>
          <div class="qr-img">
            <div class="col-md-6"><img class="scan-img" src="../../../assets/Images/mfa/mobile-qr.png" alt="">
            </div>
            <div class="col-md-6">
              <div class="userDetails__subText">Authenticator app</div>
              <div class="steps__description">
                Authencate using a code generated by an app installed on your mobile device or computer
              </div>
            </div>
          </div>
        </div>
      }
      @if (mfaAutentication==='step3') {
        <div class="qr-details">
          <p class="userManagementUsersList__user-management-section1">Set Up Your authenticator app</p>
          <div class="steps__text">
            Install a compatible application such as Google Authenticator, Authenticator, Duo Mobile, or Authy app
            on your
            mobile device or computer
          </div>
          <div class="qr-img">
            <div class="col-md-6">
              <span>
                <img [src]="qrCode" alt="qrCode">
              </span>
            </div>
            <div class="col-md-6">
              <div class="steps__description">
                Open your authenticator app, chose Show QR Code on this page, then use the app to scan the
                code,
                Alternatively, you can type a secret key.
              </div>
            </div>
          </div>
          <hr>
            <form [formGroup]="totpForm" class="totp-form">
              <div class="totp-text-width">
                <app-input-filed label="Enter TOTP below" placeholder="Enter TOTP" [control]="$any(totpForm).controls['totp']"
                [starIcon]="'*'" [maxDigits]="6" type="number"></app-input-filed>
                @if (errorMessage) {
                  <small class="text-danger">{{errorMessage}}</small>
                }
                @if (totpForm.get('totp')?.invalid &&
                  (totpForm.get('totp')?.dirty ||
                  totpForm.get('totp')?.touched)) {
                  <div>
                    @if (totpForm.get('totp')?.errors?.['required']) {
                      <div>
                        <small class="text-danger">TOTP is required.</small>
                      </div>
                    }
                    @if (totpForm.get('totp')?.errors?.['pattern']) {
                      <div>
                        <small class="text-danger">Invalid TOTP format.</small>
                      </div>
                    }
                  </div>
                }
              </div>
            </form>
          </div>
        }

        <div class="offCanvas__footer">
          @if (mfaAutentication === 'step2') {
            <app-common-button buttonClass="smallbutton" buttonLabel="Cancel"
            (clickEvent)="onCloseIconClick(false)"></app-common-button>
          }
          @if (mfaAutentication === 'step2') {
            <app-common-button [loadingIcon]="loadingIcon" [disabled]="deviceForm.invalid"
              buttonClass="smallFilledButton" buttonLabel="Next"
            (clickEvent)="movetoNext(mfaAutentication)"></app-common-button>
          }
          @if (mfaAutentication === 'step3') {
            <app-common-button (clickEvent)="verifyTotp()"
            buttonClass="smallFilledButton" buttonLabel="Verify and Save" [disabled]="totpForm.invalid"></app-common-button>
          }
        </div>
      </div>
    </div>


    @if (isToster) {
      <app-toast [title]="message" (closeToaster)="closeToster($event)"></app-toast>
    }